export default (items, mapFn) => {
  if (Array.isArray(items)) {
    return items.filter(Boolean).map(mapFn).filter(Boolean).sort();
  }
  return items ? mapFn(items) : null;
};